import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './UserSettingsModal.css';
import { supabase } from '../lib/supabase';
import MyKuraTab from './MyKuraTab';
import RequestHistory from './RequestHistory';

const UserSettingsModal = ({ user, onClose }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('myKura');
  const previousCollectionIdRef = useRef(null);

  // Auto close modal only when switching to a different collection (not when initially opening on collection page)
  useEffect(() => {
    const match = location.pathname.match(/\/collection\/([^/]+)/);
    if (match) {
      const currentCollectionId = match[1];
      // Only close if we're switching from one collection to another
      if (previousCollectionIdRef.current !== null && previousCollectionIdRef.current !== currentCollectionId) {
        onClose();
      }
      previousCollectionIdRef.current = currentCollectionId;
    } else {
      // Reset when not on a collection page
      previousCollectionIdRef.current = null;
    }
  }, [location.pathname, onClose]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === 'user-settings-overlay') {
      onClose();
    }
  };

  return (
    <div className="user-settings-overlay" onClick={handleOverlayClick}>
      <div className="user-settings-modal">
        <button className="modal-close-button" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div className="user-settings-content">
          <div 
            className={`menu-item my-kura ${activeTab === 'myKura' ? 'active' : ''}`}
            onClick={() => setActiveTab('myKura')}
          >
            <div className="menu-icon"><img src={'/box-icon.png'} alt='Box Icon'/></div>
            <span>My Kura</span>
          </div>
          <div 
            className={`menu-item ${activeTab === 'history' ? 'active' : ''}`}
            onClick={() => setActiveTab('history')}
          >
            <div className="menu-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 6V10L13 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span>History</span>
          </div>
          <div 
            className={`menu-item ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            <div className="menu-icon"><img src={'/setting-icon.png'} alt='Settings Icon'/></div>
            <span>Settings</span>
          </div>
          <div 
            className={`menu-item ${activeTab === 'account' ? 'active' : ''}`}
            onClick={() => setActiveTab('account')}
          >
            <div className="menu-icon"><img src={'/profile-icon.png'} alt='Profile Icon'/></div>
            <span>Account</span>
          </div>
          <div 
            className={`menu-item ${activeTab === 'contact' ? 'active' : ''}`}
            onClick={() => setActiveTab('contact')}
          >
            <div className="menu-icon"><img src={'/letter-icon.png'} alt='Letter Icon'/></div>
            <span>Contact us</span>
          </div>

          <div className="user-profile-info">
            <div className="user-avatar">
              <img 
                src={user?.user_metadata?.avatar_url || '/user-profile.png'} 
                alt="User Avatar" 
              />
            </div>
            <div className="user-details">
              <div className="user-name">
                {user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'User'}
              </div>
              <div className="user-email">
                {user?.email || ''}
              </div>
            </div>
          </div>

          {/* Log out */}
          <div className="menu-item logout" onClick={handleLogout}>
            <span>Log out</span>
          </div>
        </div>

        <div className="tab-content-area">
          {activeTab === 'myKura' && (
            <div className="tab-content">
              <h2>{`${(user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'User') + '\'s Kura'}`}</h2>
              <MyKuraTab />
            </div>
          )}
          {activeTab === 'settings' && (
            <div className="tab-content">
              <h2>Settings</h2>
            </div>
          )}
          {activeTab === 'account' && (
            <div className="tab-content">
              <h2>Account</h2>
            </div>
          )}
          {activeTab === 'history' && (
            <div className="tab-content">
              <RequestHistory onRequestSelect={onClose} />
            </div>
          )}
          {activeTab === 'contact' && (
            <div className="tab-content">
              <h2>Contact us</h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserSettingsModal;

